import { Camera2D } from "./Scene2DSpecial/Camera2D";
import { Sprite } from "./Sprite";
import { Point } from "../maths/Point";
import { RenderState2D } from "../webgl/utils/RenderState2D";
import { LayaGL } from "../layagl/LayaGL";
import { SpriteConst } from "./SpriteConst";
import { Matrix } from "../maths/Matrix";
import { LayaEnv } from "../../LayaEnv";
import { ILaya } from "../../ILaya";
export class Area2D extends Sprite {
    constructor() {
        super();
        this._renderType |= SpriteConst.AREA2D;
        this._initShaderData();
        this._globalRenderData = LayaGL.render2DRenderPassFactory.create2DGlobalRenderDataHandle();
        this._globalRenderData.globalShaderData = this._globalShaderData = LayaGL.renderDeviceFactory.createShaderData(null);
        this._globalRenderData.renderLayerMask = -1;
        this._struct.globalRenderData = this._globalRenderData;
    }
    get mainCamera() {
        return this._mainCamera;
    }
    _setMainCamera(camera) {
        if (camera == this._mainCamera || !LayaEnv.isPlaying)
            return;
        this._mainCamera && (this._mainCamera._isMain = false);
        if (camera) {
            camera._isMain = true;
            this._globalShaderData.addDefine(Camera2D.SHADERDEFINE_CAMERA2D);
        }
        else {
            this._globalShaderData.removeDefine(Camera2D.SHADERDEFINE_CAMERA2D);
        }
        this._mainCamera = camera;
    }
    render() {
        if (this._mainCamera) {
            if (this._globalShaderData) {
                this._globalRenderData.renderLayerMask = this._mainCamera.visiableLayer;
                this._globalRenderData.cullRect = this._mainCamera._rect;
                this._globalShaderData.setMatrix3x3(Camera2D.VIEW2D, this._mainCamera._getCameraTransform());
            }
        }
    }
    _setBelongScene(scene) {
        super._setBelongScene(scene);
        this._scene._area2Ds.add(this);
    }
    _setUnBelongScene() {
        this._scene._area2Ds.delete(this);
        super._setUnBelongScene();
    }
    localToView(x, y, out) {
        out = out || new Point();
        out.setTo(x, y);
        this.localToGlobal(out);
        this.transformPoint(out.x, out.y, out);
        return out;
    }
    transformPoint(x, y, out) {
        out = out || new Point();
        out.setTo(x, y);
        if (!this._mainCamera) {
            return out;
        }
        let halfWidth = RenderState2D.width * 0.5;
        let halfHeight = RenderState2D.height * 0.5;
        let c_x = x * ILaya.stage.clientScaleX - halfWidth;
        let c_y = y * ILaya.stage.clientScaleY - halfHeight;
        this._mainCamera._getCameraTransform();
        let cameraMatrix = this._mainCamera.cameraMatrix;
        let elements = cameraMatrix.elements;
        let newX = elements[0] * c_x + elements[3] * c_y + elements[6];
        let newY = elements[1] * c_x + elements[4] * c_y + elements[7];
        let matrix = Matrix.TEMP;
        this._globalTrans.getMatrixInv(matrix);
        out.x = matrix.a * newX + matrix.c * newY + matrix.tx;
        out.y = matrix.b * newX + matrix.d * newY + matrix.ty;
        return out;
    }
    inverseTransformPoint(x, y, out) {
        out = out || new Point();
        out.setTo(x, y);
        if (!this._mainCamera) {
            return out;
        }
        let areaMatrix = this._globalTrans.getMatrix();
        let globalX = areaMatrix.a * x + areaMatrix.c * y + areaMatrix.tx;
        let globalY = areaMatrix.b * x + areaMatrix.d * y + areaMatrix.ty;
        let viewElements = this._mainCamera._getCameraTransform().elements;
        out.x = (viewElements[0] * globalX + viewElements[3] * globalY + viewElements[6] + RenderState2D.width * 0.5) / ILaya.stage.clientScaleX;
        out.y = (viewElements[1] * globalX + viewElements[4] * globalY + viewElements[7] + RenderState2D.height * 0.5) / ILaya.stage.clientScaleY;
        return out;
    }
}
